













































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import DateRangePicker from '@/components/material/DateRangePicker/index.vue';
import {
  formatDate,
  translateComponentResource,
  stringToIDate,
  getFilenameWithoutSuffixFromUrl,
  downloadFileFromUrl,
  formatApiError,
} from '@/utils/index';
import {
  sortByPlanAndUnit,
  PlanAndUnitWithBookingType,
  planAndUnitWithBookingTypeToText,
} from '@/utils/tickets';
import { AppModule } from '@/store/modules/app';
import {
  IReportRequest,
  IReportRequestSourceIdHolder,
  IDownloadIssuingRecordsResponse,
  downloadIssuingReport,
} from '@/api/report';
import { IDate, BookingTypeEnum, IExternalAccount } from '@/api/types';
import {
  IListPlansRequest,
  IListPlansResponse,
  listPlans,
} from '@/api/tickets';
import {
  IListAccountsRequest,
  IListAccountsResponse,
  listAccounts,
} from '@/api/users';
import { ReportModule, ReportSearchForm } from '@/store/modules/report';

@Component({
  name: 'ReportSearchForm',
  components: {
    MaterialCard,
    DateRangePicker,
  },
})
export default class extends Vue {
  private readonly naiveToday = formatDate(new Date());
  private issuingDateRangeMenu = false;
  private issuingDateRange: string[] = [];
  private participationDateMenu = false;
  private participationDateRange: string[] = [];
  private sourceIds: PlanAndUnitWithBookingType[] = [];
  private sourceIdsLoading = true;
  private planAndUnitItems: PlanAndUnitWithBookingType[] = [];
  private accountIds: IExternalAccount[] = [];
  private accounts: IExternalAccount[] = [];
  private accountIdsLoading = true;
  private searchAccountId = '';
  private valid = true;
  private allowDownload = true;

  get formattedIssuingDateRange() {
    return this.formatDateRange(this.issuingDateRange);
  }

  get formattedParticipationDateRange() {
    return this.formatDateRange(this.participationDateRange);
  }

  get canSubmit() {
    return (
      this.valid && this.issuingDateRange && this.issuingDateRange.length > 0
    );
  }

  get canDownload() {
    return (
      this.allowDownload &&
      this.issuingDateRange &&
      this.issuingDateRange.length > 0
    );
  }

  mounted() {
    this.fetchData().then(() => this.loadFormModelFromStore());
  }

  private async fetchData() {
    AppModule.StartProgress();

    this.sourceIdsLoading = true;
    this.accountIdsLoading = true;

    [this.planAndUnitItems, this.accounts] = await Promise.all([
      this.fetchPlanAndUnitItems(),
      this.fetchAccounts(),
    ]);

    this.sourceIdsLoading = false;
    this.accountIdsLoading = false;

    AppModule.StopProgress();
  }

  private async fetchPlanAndUnitItems() {
    let res;
    try {
      res = await listPlans({} as IListPlansRequest);
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Plan name'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
      return [];
    }

    const planAndUnitItems = res.plans
      .flatMap(plan => {
        const items: PlanAndUnitWithBookingType[] = [];
        if (plan.units && plan.units.length > 0) {
          plan.units.forEach(unit => {
            const item = {
              activityId: plan.activityId,
              activityTitle: plan.activityTitle,
              planId: plan.planId,
              planTitle: plan.planTitle,
              unitId: unit.id,
              unitTitle: unit.title,
              bookingType: plan.bookingType || BookingTypeEnum.EACH_TIME,
            } as PlanAndUnitWithBookingType;
            items.push(item);
          });
        } else {
          items.push({
            activityId: plan.activityId,
            activityTitle: plan.activityTitle,
            planId: plan.planId,
            planTitle: plan.planTitle,
            unitId: '',
            unitTitle: '',
            bookingType: plan.bookingType || BookingTypeEnum.EACH_TIME,
          } as PlanAndUnitWithBookingType);
        }

        return items;
      })
      .sort(sortByPlanAndUnit);
    return planAndUnitItems;
  }

  private async fetchAccounts() {
    try {
      const res = await listAccounts({} as IListAccountsRequest);
      return res.accounts;
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Account name'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
      return [];
    }
  }

  private loadFormModelFromStore() {
    ReportModule.LoadReportSearchForm();
    this.issuingDateRange = ReportModule.searchForm.issuingDateRange;
    this.participationDateRange =
      ReportModule.searchForm.participationDateRange;
    this.sourceIds = ReportModule.searchForm.sourceIds;
    this.accountIds = ReportModule.searchForm.accountIds;
  }

  submit() {
    ReportModule.SaveReportSearchForm({
      issuingDateRange: this.issuingDateRange,
      participationDateRange: this.participationDateRange,
      sourceIds: this.sourceIds,
      accountIds: this.accountIds,
    } as ReportSearchForm);
    this.$router.push({
      name: 'report-search-result',
      query: {
        issuingDateRange: JSON.stringify(this.issuingDateRange),
        participationDateRange: JSON.stringify(this.participationDateRange),
        sourceIds: JSON.stringify(this.sourceIds),
        accountIds: JSON.stringify(this.accountIds),
      },
    });
  }

  reset() {
    (this.$refs.form as any).reset();
    this.issuingDateRange = [];
    this.participationDateRange = [];
  }

  async download() {
    this.allowDownload = false;
    AppModule.StartProgress();

    const req = {} as IReportRequest;
    let searchConditions = [];

    if (this.issuingDateRange && this.issuingDateRange.length == 2) {
      req.issuingDateRange = {
        start: stringToIDate(this.issuingDateRange[0]) as IDate,
        end: stringToIDate(this.issuingDateRange[1]) as IDate,
      };
      this.issuingDateRange;
    }

    let participationDateRange: string[] = [];
    if (
      this.participationDateRange &&
      this.participationDateRange.length == 2
    ) {
      req.participationDateRange = {
        start: stringToIDate(this.participationDateRange[0]) as IDate,
        end: stringToIDate(this.participationDateRange[1]) as IDate,
      };
    }

    if (this.sourceIds && this.sourceIds.length > 0) {
      req.sourceIds = this.sourceIds.map(
        item =>
          ({
            planId: item.planId,
            unitId: item.unitId,
          } as IReportRequestSourceIdHolder)
      );
    }

    if (this.accountIds && this.accountIds.length > 0) {
      req.accountIds = this.accountIds.map(a => a.id);
    }

    try {
      const res = await downloadIssuingReport(req);
      const filename = `${getFilenameWithoutSuffixFromUrl(res.url)}.csv`;
      downloadFileFromUrl(res.url, filename);
      this.$toast.success(this.$t('Downloaded CSV') as string, {
        icon: 'mdi-file-download',
      });

      AppModule.StopProgress();
      this.allowDownload = true;
    } catch (err) {
      AppModule.StopProgress();
      this.allowDownload = true;
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t(`Download`) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private translateComponentResource(
    resource: string,
    options?: { [key: string]: any }
  ) {
    return translateComponentResource(
      this.$i18n,
      this.$options.name as string,
      resource,
      options
    );
  }

  private formatDateRange(dateRange: string[]) {
    if (dateRange.length > 0) {
      let range = formatDate(new Date(dateRange[0]));
      if (dateRange.length > 1) {
        range += ' - ' + formatDate(new Date(dateRange[1]));
      }
      return range;
    }
    return '';
  }

  private planAndUnitItemsText(item: PlanAndUnitWithBookingType) {
    return planAndUnitWithBookingTypeToText(this.$i18n, item);
  }

  private accountItemText(item: IExternalAccount) {
    return item.fullName;
  }

  private accountItemValue(item: IExternalAccount) {
    return item.id;
  }
}
